/**
 * Format decimal hours to "Xh Ym" format
 * @param {number} decimalHours - Hours as decimal (e.g., 4.97)
 * @returns {string} Formatted string (e.g., "4h 58m")
 */
export const formatDecimalHours = (decimalHours) => {
  if (!decimalHours || decimalHours === 0) {
    return '0h 0m';
  }
  
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);
  
  return `${hours}h ${minutes}m`;
};

/**
 * Format decimal hours to hours only (e.g., "4.97 hrs" -> "5 hrs")
 * @param {number} decimalHours - Hours as decimal
 * @returns {string} Formatted string with rounded hours
 */
export const formatHoursRounded = (decimalHours) => {
  if (!decimalHours || decimalHours === 0) {
    return '0 hrs';
  }
  
  return `${Math.round(decimalHours)} hrs`;
};
